<template>
  <VSelect v-model="model" :clearable :disabled filterable :label="placeholder ? undefined : $t('roles')" multiple :placeholder :size>
    <VOption v-for="role in visibleRoles" :key="role.id" :label="$tk(role.name)" :value="role.name" />
  </VSelect>
</template>

<script setup lang="ts">
import type { VInputSize } from '@vartion/ui'

import { APP_MODULE_ROLES, useRoles } from '~/stores/roles.ts'

interface Props {
  disabled?: boolean
  administrationRolesVisible?: boolean
  size?: VInputSize
  placeholder?: string
  clearable?: boolean
}

const { disabled = undefined, administrationRolesVisible = false, size = undefined, placeholder = undefined, clearable = undefined } = defineProps<Props>()

const model = defineModel<string[]>({ required: true })

const store = useRoles()

const visibleRoles = computed(() => {
  let visibleRoles = administrationRolesVisible ? store.roles : store.appRoles

  return Object.values(visibleRoles).filter((role) => !APP_MODULE_ROLES.has(role.name))
})
</script>
